import { Button, Menu, MenuItem, Navbar } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import logo from '../../../assets/diatera_no_sub.png';
import logoWhite from '../../../assets/diatera_white_no_sub.png';
import logoOnly from '../../../assets/diatera_logo_only.png';
import { RootState, useTypedDispatch } from '../../../stores';
import { setUser } from '../../../stores/user';
import { clearLocalStorage } from '../../../utils/storage';
import NoNotif from '../../elements/NoNotif';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import HeaderContext from './HeaderContext';
import styles from './header.module.css';

interface Props {
  className?: string,
  collapse?: boolean,
}

const Header: React.FC<Props> = ({ className, collapse }) => {
  const { content } = useContext(HeaderContext);
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  const { dark } = useSelector((s: RootState) => s.ui);
  const { name } = useSelector((s: RootState) => s.user).user;
  const { width } = useWindowDimensions();

  const logout = useCallback(() => {
    dispatch(setUser({ id: -1, email: '', name: '', roleId: -1, token: '', role: null }));
    clearLocalStorage();
    navigate('/login');
  }, [dispatch, navigate]);

  return (
    <div className={className}>
      <Navbar>
        {
          (width > 767 || (width <= 767 && content == null)) &&
          <Navbar.Group className={collapse ? styles.collapse : styles.expand}>
            <img
              className={styles.logo}
              height={18}
              src={collapse ? logoOnly : (dark ? logoWhite : logo)}
              alt="PT Diatera Cipta Teknologi"
            />
          </Navbar.Group>
        }

        <Navbar.Group>
          {content}
        </Navbar.Group>

        { 
          width > 767 &&
          <>
            <Navbar.Group align="right">
              <Popover2
                className={styles.desktop}
                content={<NoNotif />}
                interactionKind="click"
                placement="bottom-end"
                renderTarget={({ isOpen, ref, ...targetProps }) => (
                  <Button {...targetProps} minimal elementRef={ref!} icon="notifications" />
                )}
              />
              <Navbar.Divider className={styles.desktop} />

              <Popover2
                className={styles.desktop}
                content={
                  <Menu>
                    <MenuItem icon="user" text="Profile" onClick={()=>navigate('/profile')} />
                    <MenuItem icon="log-out" text="Log out" onClick={logout} />
                  </Menu>
                }
                interactionKind="click"
                placement="bottom-end"
                renderTarget={({ isOpen, ref, ...targetProps }) => (
                  <Button {...targetProps} minimal elementRef={ref!} icon="user" text={name} />
                )}
              />
            </Navbar.Group>
          </>
        }
      </Navbar>
    </div>
  );
};

export default Header;
